module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div id="bdemcoll" class="table_BriqueDemandesCollaborateurs"></div>';
}
return __p;
};
